import { useEffect } from "react";
import { useIntl } from "react-intl";
import { makeStyles } from "tss-react/mui";
import withRoot from "@/withRoot";
import route_map from "@/config/route_map";
import styles from "./notFound.style";
import pic_2 from "@/assets/404-2.png";

const useStyles = makeStyles()(styles);

function NotFound() {
  const intl = useIntl();
  const { classes } = useStyles();
  const indexLink = window.location.origin + "/";

  useEffect(() => {
    document.title = intl.formatMessage({ id: "notFound.title" });
    let robots = document.head.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex,nofollow");
  }, [intl]);

  return (
    <div className={classes.wrap}>
      <img src={pic_2} height="264" />
      <p className={classes.desc}>
        {intl.formatMessage({ id: "common.cannotFound1" })}
      </p>
      <a className={classes.link} href={indexLink}>
        {intl.formatMessage({ id: "common.homepage1" })}
        <span>&gt;</span>
      </a>
    </div>
  );
}

export default withRoot(NotFound);
